import {
	FETCH_PAYMENT_METHODS,
	FETCH_PAYMENT_METHODS_SUCCESS,
	FETCH_PAYMENT_METHODS_FAILED,
	UPDATE_WALLET_BALANCE,
	UPDATE_WALLET_BALANCE_SUCCESS,
	UPDATE_WALLET_BALANCE_FAILED,
	CLEAR_PAYMENT_MESSAGES,
	UPDATE_PAYMENT_METHOD,
} from "../store/types";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from "../config/configureFirebase";
import store from "../store/store";
import { onValue, get, update, push } from "firebase/database";
import { Platform } from "react-native";

export const fetchPaymentMethods = () => (dispatch) => {
	try {
		// FIXED: Add validation for firebase object
		if (!firebase) {
			console.error(
				"❌ Firebase object is null/undefined in fetchPaymentMethods"
			);
			dispatch({
				type: FETCH_PAYMENT_METHODS_FAILED,
				payload: "Firebase not initialized",
			});
			return;
		}

		// FIXED: Add validation for update function
		if (!firebase.update) {
			console.error(
				"❌ Firebase update function is missing in fetchPaymentMethods"
			);
			dispatch({
				type: FETCH_PAYMENT_METHODS_FAILED,
				payload: "Firebase update function not available",
			});
			return;
		}

		// FIXED: Add retry mechanism for Firebase initialization
		let retryCount = 0;
		const maxRetries = 3;

		const attemptFetch = () => {
			try {
				const { config, paymentSettingsRef } = firebase;

				// FIXED: Add null checks for Firebase objects
				if (!paymentSettingsRef) {
					console.error(
						"PaymentSettingsRef is undefined, retry:",
						retryCount
					);
					if (retryCount < maxRetries) {
						retryCount++;
						setTimeout(attemptFetch, 1000); // Retry after 1 second
						return;
					} else {
						dispatch({
							type: FETCH_PAYMENT_METHODS_FAILED,
							payload: "Firebase configuration error",
						});
						return;
					}
				}

				dispatch({
					type: FETCH_PAYMENT_METHODS,
					payload: null,
				});

				const usertype = store.getState().auth.profile?.usertype;

				if (usertype == "admin") {
					onValue(
						paymentSettingsRef,
						(snapshot) => {
							try {
								const data = snapshot.val();
								if (data) {
									const arr = Object.keys(data).map((i) => {
										data[i].id = i;
										return data[i];
									});
									dispatch({
										type: FETCH_PAYMENT_METHODS_SUCCESS,
										payload: arr,
									});
								} else {
									dispatch({
										type: FETCH_PAYMENT_METHODS_FAILED,
										payload:
											store.getState().languagedata
												.defaultLanguage
												.no_provider_found,
									});
								}
							} catch (error) {
								console.error(
									"Error processing payment methods data:",
									error
								);
								dispatch({
									type: FETCH_PAYMENT_METHODS_FAILED,
									payload: "Error processing payment methods",
								});
							}
						},
						(error) => {
							console.error("Firebase onValue error:", error);
							dispatch({
								type: FETCH_PAYMENT_METHODS_FAILED,
								payload: "Firebase connection error",
							});
						}
					);
				} else {
					// FIXED: Use real-time listener for non-admin users too
					// This ensures payment methods update automatically when admin adds new ones
					onValue(
						paymentSettingsRef,
						(snapshot) => {
							try {
								const data = snapshot.val();
								if (data) {
									const arr = Object.keys(data).map((i) => {
										data[i].id = i;
										return data[i];
									});
									// Filter only active providers for non-admin users
									const activeProviders = arr.filter(
										(provider) => provider.active === true
									);
									dispatch({
										type: FETCH_PAYMENT_METHODS_SUCCESS,
										payload: activeProviders,
									});
								} else {
									dispatch({
										type: FETCH_PAYMENT_METHODS_FAILED,
										payload:
											store.getState().languagedata
												.defaultLanguage
												.no_provider_found,
									});
								}
							} catch (error) {
								console.error(
									"Error processing payment methods data:",
									error
								);
								dispatch({
									type: FETCH_PAYMENT_METHODS_FAILED,
									payload: "Error processing payment methods",
								});
							}
						},
						(error) => {
							console.error("Firebase onValue error:", error);
							dispatch({
								type: FETCH_PAYMENT_METHODS_FAILED,
								payload: "Firebase connection error",
							});
						}
					);
				}
			} catch (error) {
				console.error("Error in attemptFetch:", error);
				if (retryCount < maxRetries) {
					retryCount++;
					setTimeout(attemptFetch, 1000);
				} else {
					dispatch({
						type: FETCH_PAYMENT_METHODS_FAILED,
						payload: "Error fetching payment methods",
					});
				}
			}
		};

		// Start the fetch attempt
		attemptFetch();
	} catch (error) {
		console.error("Error in fetchPaymentMethods:", error);
		dispatch({
			type: FETCH_PAYMENT_METHODS_FAILED,
			payload: "Error fetching payment methods",
		});
	}
};

export const editPaymentMethods = (data) => (dispatch) => {
	try {
		// FIXED: Add validation for firebase object
		if (!firebase) {
			console.error(
				"❌ Firebase object is null/undefined in editPaymentMethods"
			);
			return;
		}

		// FIXED: Add validation for update function
		if (!firebase.update) {
			console.error(
				"❌ Firebase update function is missing in editPaymentMethods"
			);
			return;
		}

		// FIXED: Add retry mechanism for Firebase initialization
		let retryCount = 0;
		const maxRetries = 3;

		const attemptUpdate = () => {
			try {
				const { editPaymentSettingRef } = firebase;

				if (!editPaymentSettingRef) {
					console.error(
						"editPaymentSettingRef is undefined, retry:",
						retryCount
					);
					if (retryCount < maxRetries) {
						retryCount++;
						setTimeout(attemptUpdate, 1000); // Retry after 1 second
						return;
					} else {
						console.error(
							"Failed to initialize Firebase after retries"
						);
						return;
					}
				}

				dispatch({
					type: UPDATE_PAYMENT_METHOD,
					payload: data,
				});

				// FIXED: Use proper Firebase update function with error handling
				if (data && data.id) {
					update(editPaymentSettingRef(data.id), data).catch(
						(error) => {
							console.error(
								"Error updating payment method:",
								error
							);
						}
					);
				} else {
					console.error("Invalid data for payment method update:", {
						data,
					});
				}
			} catch (error) {
				console.error("Error in attemptUpdate:", error);
				if (retryCount < maxRetries) {
					retryCount++;
					setTimeout(attemptUpdate, 1000);
				}
			}
		};

		// Start the update attempt
		attemptUpdate();
	} catch (error) {
		console.error("Error in editPaymentMethods:", error);
	}
};

export const clearMessage = () => (dispatch) => {
	dispatch({
		type: CLEAR_PAYMENT_MESSAGES,
		payload: null,
	});
};

export const addToWallet =
	(uid, amount, description = "AdminCredit") =>
	async (dispatch) => {
		const { walletHistoryRef, singleUserRef, settingsRef } = firebase;

		dispatch({
			type: UPDATE_WALLET_BALANCE,
			payload: null,
		});

		const settingsdata = await get(settingsRef);
		const settings = settingsdata.val();

		console.log("🔄 Pre Adding to wallet", uid, amount);
		onValue(
			singleUserRef(uid),
			(snapshot) => {
				console.log("🔄 Adding to wallet", uid, amount);
				if (snapshot.val()) {
					let walletBalance = parseFloat(
						snapshot.val().walletBalance
					);
					const pushToken = snapshot.val().pushToken;
					walletBalance = parseFloat(
						(
							parseFloat(walletBalance) + parseFloat(amount)
						).toFixed(settings.decimal)
					);
					let details = {
						type: "Credit",
						amount: parseFloat(amount),
						date: new Date().getTime(),
						txRef: description,
					};
					console.log(
						"🔄 Updating wallet balance",
						uid,
						walletBalance
					);
					update(singleUserRef(uid), { walletBalance: walletBalance })
						.then(() => {
							console.log(
								"🔄 Updating wallet balance",
								uid,
								walletBalance
							);
							push(walletHistoryRef(uid), details)
								.then(() => {
									console.log(
										"🔄 Updating wallet balance success",
										uid,
										walletBalance
									);
									dispatch({
										type: UPDATE_WALLET_BALANCE_SUCCESS,
										payload: null,
									});
								})
								.catch((error) => {
									dispatch({
										type: UPDATE_WALLET_BALANCE_FAILED,
										payload:
											error.code + ": " + error.message,
									});
								});
							if (pushToken) {
								RequestPushMsg(pushToken, {
									title: store.getState().languagedata
										.defaultLanguage.notification_title,
									msg: store.getState().languagedata
										.defaultLanguage.wallet_updated,
									screen: "Wallet",
									channelId: "general",
									sound:
										Platform.OS === "android"
											? "general"
											: "general.mp3", // Correct format for each platform
								});
							}
						})
						.catch((error) => {
							dispatch({
								type: UPDATE_WALLET_BALANCE_FAILED,
								payload: error.code + ": " + error.message,
							});
						});
				}
			},
			{ onlyOnce: true }
		);
	};

export const deductFromWallet =
	(uid, amount, description = "AdminDebit") =>
	async (dispatch) => {
		const { walletHistoryRef, singleUserRef, settingsRef } = firebase;

		dispatch({
			type: UPDATE_WALLET_BALANCE,
			payload: null,
		});

		try {
			const settingsdata = await get(settingsRef);
			const settings = settingsdata.val();

			console.log(
				"💰 Pre Deducting from wallet",
				uid,
				amount,
				"Description:",
				description
			);

			// Use get() for reliable one-time read
			const snapshot = await get(singleUserRef(uid));
			console.log("💰 Read user data from database", uid);

			// Check if user data exists
			if (!snapshot.exists() || !snapshot.val()) {
				console.error("❌ User not found in database:", uid);
				dispatch({
					type: UPDATE_WALLET_BALANCE_FAILED,
					payload: "User not found",
				});
				throw new Error("User not found");
			}

			let walletBalance = parseFloat(snapshot.val().walletBalance || 0);
			const pushToken = snapshot.val().pushToken;

			// Check if this is a cancellation fee - allow negative balance for cancellation fees
			const isCancellationFee = description
				.toLowerCase()
				.includes("cancellation");
			console.log("🔍 Cancellation fee check:", {
				description,
				isCancellationFee,
			});

			// Log balance check
			console.log("💰 Balance check:", {
				walletBalance,
				amount: parseFloat(amount),
				isCancellationFee,
				willAllowNegative:
					isCancellationFee && walletBalance < parseFloat(amount),
			});

			// Check if user has sufficient balance
			// Only enforce balance check if NOT a cancellation fee
			if (!isCancellationFee && walletBalance < parseFloat(amount)) {
				console.error(
					"❌ Insufficient wallet balance (non-cancellation):",
					{
						walletBalance,
						amount: parseFloat(amount),
						description,
					}
				);
				dispatch({
					type: UPDATE_WALLET_BALANCE_FAILED,
					payload: "Insufficient wallet balance",
				});
				throw new Error("Insufficient wallet balance");
			}

			// For cancellation fees, allow negative balance
			if (isCancellationFee && walletBalance < parseFloat(amount)) {
				console.log(
					"⚠️ Insufficient balance for cancellation fee. Allowing negative balance:",
					{
						currentBalance: walletBalance,
						feeAmount: parseFloat(amount),
						willBeNegative: true,
					}
				);
			}

			walletBalance = parseFloat(
				(parseFloat(walletBalance) - parseFloat(amount)).toFixed(
					settings.decimal
				)
			);
			let details = {
				type: "Debit",
				amount: parseFloat(amount),
				date: new Date().getTime(),
				txRef: description,
			};
			console.log("💰 Attempting Firebase update:", {
				uid,
				newBalance: walletBalance,
				amount: parseFloat(amount),
				description,
			});

			// Update wallet balance
			await update(singleUserRef(uid), {
				walletBalance: walletBalance,
			});
			console.log(
				"✅ Firebase wallet balance updated successfully",
				uid,
				walletBalance
			);

			// Verify the update was actually saved
			try {
				const verifySnapshot = await get(singleUserRef(uid));
				const verifiedBalance = parseFloat(
					verifySnapshot.val()?.walletBalance || 0
				);
				console.log("🔍 Wallet balance verification:", {
					expected: walletBalance,
					actual: verifiedBalance,
					match: Math.abs(verifiedBalance - walletBalance) < 0.01,
				});

				if (Math.abs(verifiedBalance - walletBalance) > 0.01) {
					console.error("❌ Wallet balance mismatch!", {
						expected: walletBalance,
						actual: verifiedBalance,
						difference: verifiedBalance - walletBalance,
						uid,
						amount: parseFloat(amount),
						description,
					});
				}
			} catch (verifyError) {
				console.error(
					"❌ Error verifying wallet balance:",
					verifyError
				);
			}

			console.log("💰 Attempting wallet history push:", {
				uid,
				details,
			});

			// Push wallet history
			await push(walletHistoryRef(uid), details);
			console.log(
				"✅ Wallet deduction completed successfully",
				uid,
				walletBalance
			);

			dispatch({
				type: UPDATE_WALLET_BALANCE_SUCCESS,
				payload: null,
			});

			if (pushToken) {
				RequestPushMsg(pushToken, {
					title: store.getState().languagedata.defaultLanguage
						.notification_title,
					msg: store.getState().languagedata.defaultLanguage
						.wallet_updated,
					screen: "Wallet",
					channelId: "general",
					sound:
						Platform.OS === "android" ? "general" : "general.mp3",
				});
			}
		} catch (error) {
			console.error("❌ Error in deductFromWallet:", {
				errorCode: error.code,
				errorMessage: error.message,
				errorStack: error.stack,
				uid,
				amount,
				description,
			});
			dispatch({
				type: UPDATE_WALLET_BALANCE_FAILED,
				payload:
					error.code && error.message
						? error.code + ": " + error.message
						: error.message || "Unknown error",
			});
			throw error;
		}
	};

// Helper function to generate unique transaction ID
const generateTransactionId = (prefix = "WTH") => {
	const timestamp = Date.now();
	const date = new Date();
	const year = date.getFullYear().toString().slice(-2); // Last 2 digits of year
	const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month with leading zero
	const day = date.getDate().toString().padStart(2, "0"); // Day with leading zero
	const hours = date.getHours().toString().padStart(2, "0"); // Hours with leading zero
	const minutes = date.getMinutes().toString().padStart(2, "0"); // Minutes with leading zero
	const seconds = date.getSeconds().toString().padStart(2, "0"); // Seconds with leading zero

	// Generate random string for uniqueness
	const random = Math.random().toString(36).substring(2, 6).toUpperCase();

	// Format: WTH-YYMMDD-HHMMSS-RAND
	return `${prefix}-${year}${month}${day}-${hours}${minutes}${seconds}-${random}`;
};

export const withdrawBalance = (profile, amount) => async (dispatch) => {
	const { withdrawRef } = firebase;

	dispatch({
		type: UPDATE_WALLET_BALANCE,
		payload: null,
	});

	// Get current balance from profile
	const currentBalance = parseFloat(profile.walletBalance) || 0;

	// Generate unique transaction ID
	const transactionId = generateTransactionId("WTH"); // WTH = Withdraw

	push(withdrawRef, {
		uid: profile.uid,
		name: profile.firstName + " " + profile.lastName,
		amount: parseFloat(amount),
		date: new Date().getTime(),
		stripe_account_id: profile.stripe_account_id
			? profile.stripe_account_id
			: null,
		paypal_email: profile.paypal_email ? profile.paypal_email : null,
		currentBalance: currentBalance, // Current wallet balance
		method: "bank-transfer", // Withdrawal method
		processed: "pending", // Status: pending
		currency: profile.currency_code,
		transactionId: transactionId, // Unique transaction ID for tracking
		requestedBy: profile.uid, // User ID who requested the withdrawal
		requestedByName: profile.firstName + " " + profile.lastName, // Full name of requester
		requestedByEmail: profile.email, // Email of requester
		requestedByMobile: profile.mobile, // Mobile number of requester
		userType: profile.usertype, // Type of user (driver/customer)
		requestTimestamp: new Date().toISOString(), // ISO timestamp for better readability
		requestDate: new Date().toLocaleDateString(), // Human readable date
		requestTime: new Date().toLocaleTimeString(), // Human readable time
	});
};
